module.exports = __webpack_public_path__ + "static/media/non-veg-icon.4f72900e.svg";